import React from "react";

import "./index.scss";

const BaselineIcon = props => (
  <svg id="Basline_SVG" data-name="Reports" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="baseline-icon">
    <g id="Group_11342" data-name="Group 11342" transform="translate(-1390 -7428)" className={`default ${props.active ? "active" : ""}`}>
      <rect id="Rectangle_845" data-name="Rectangle 845" className="cls-1" width="32" height="32" transform="translate(1390 7428)" />
      <path
        id="Path_9742"
        data-name="Path 9742"
        className="cls-2"
        d="M2757.822,6757.105c4.382,0,10.708-.887,16.024-4.866,4.585-3.924,7.195-8.372,7.976-13.321"
        transform="translate(-1363.822 693.082)"
      />
      <path id="Path_9743" data-name="Path 9743" className="cls-3" d="M2778.265,6743.291h-24" transform="translate(-1360.265 712.71)" />
    </g>
  </svg>
);

export default BaselineIcon;
